import { Router } from '@angular/router';
import { NavigationEnd } from '@angular/router';
import { Component, ComponentFactoryResolver, OnInit, ViewChild, ViewContainerRef, AfterViewInit } from '@angular/core';
import { CompareVersionsComponent } from "../Cms/compare-versions/compare-versions.component";
import { MatDialog } from "@angular/material/dialog";
import { MainService } from '../Services/service.service';
import * as WebFont from 'webfontloader';
@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.css']
})
export class FooterComponent implements OnInit, AfterViewInit {
    
    public enableSubscription:boolean = false;
    public enableCompareVersion:boolean = false;
    public enableLetOurPros:boolean = false;
    public enableAdvertiseWithUs:boolean = false;
  

    @ViewChild('footer', { static: false, read: ViewContainerRef }) entry: ViewContainerRef;

    public blogUrl: string;
    constructor(private router: Router, private dialog: MatDialog, public service: MainService) {
        this.enableSubscription = service.enableSubscription;
        this.enableCompareVersion = service.enableCompareVersion;
        this.enableLetOurPros = service.enableLetOurPros;
        this.enableAdvertiseWithUs = service.enableAdvertiseWithUs;
    }


    ngAfterViewInit(): void {
        //    throw new Error("Method not implemented.");
        WebFont.load({
            google: { families: ['Material Icons', 'Material Icons Outline'], },
            fontactive: (familyName, fvd) => {
                if(familyName="Material Icons"){
                    this.service.aplicationIsReady = true;
                }
            },
          });

    }

    get currentYear(): number {
        return new Date().getFullYear();
    }

    get strBlogUrl() {
        return this.service.advService.blogURL
    }



    ngOnInit() {
        this.blogUrl = this.service.advService.blogURL;

        this.router.events.subscribe((evt) => {
            if (!(evt instanceof NavigationEnd)) {
                return;
            }
            window.scrollTo(0, 0)
        });
    }

    public showCompareVersionsDialog() {
        let item = this.dialog.open(CompareVersionsComponent, {
            width: '70%',
            height: "762px",
            panelClass: "CompareVersionsComponent-panel",
            data: {
                isPopup: true
            }
        });
        item.componentInstance.isPopup = true;
        return false;
    }

}
